<template>
  <div
    class="complete-icon complete-icon--success"
  >
    <span
      class="complete-icon--success__line complete-icon--success__line--long"
    />
    <span
      class="complete-icon--success__line complete-icon--success__line--tip"
    />
    <div
      class="complete-icon--success__ring"
    />
    <div class="complete-icon--success__hide-corners" />
  </div>
</template>

<script>

export default {
  name: 'CompleteIcon'
}
</script>
<style lang="scss" scoped>
.complete-icon--success {
  border-color: var(--q-color-positive);
}

.complete-icon--success:after, .complete-icon--success:before {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg)
}

.complete-icon--success:before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 60px 60px;
  transform-origin: 60px 60px
}

.complete-icon--success:after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 0 60px;
  transform-origin: 0 60px;
  -webkit-animation: rotatePlaceholder 4.25s ease-in;
  animation: rotatePlaceholder 4.25s ease-in
}

.complete-icon--success__ring {
  width: 80px;
  height: 80px;
  border: 4px solid var(--q-color-positive);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
  opacity: 0.2;
}

.complete-icon--success__hide-corners {
  width: 5px;
  height: 90px;
  background-color: #fff;
  padding: 1px;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg)
}

.complete-icon--success__line {
  height: 5px;
  background-color:var(--q-color-positive);
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2
}

.complete-icon--success__line--tip {
  width: 25px;
  left: 14px;
  top: 46px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-animation: animateSuccessTip .75s;
  animation: animateSuccessTip .75s
}

.complete-icon--success__line--long {
  width: 47px;
  right: 8px;
  top: 38px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: animateSuccessLong .75s;
  animation: animateSuccessLong .75s
}

.complete-icon {
  width: 80px;
  height: 80px;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  margin: 20px auto
}

.complete-icon:first-child {
  margin-top: 32px
}
.body--dark .complete-icon--success__hide-corners {
  background-color: $background;
}
.body--dark .bg-responsive .complete-icon--success__hide-corners {
  background-color: $dark;
}
.body--dark .complete-icon{
  z-index: -1;
}
.body--dark .complete-icon.bg-responsive {
  z-index: 0;
}
.body--dark .complete-icon--success__ring {
  border: 4px solid var(--q-color-positive);
}

.body--dark .complete-icon--success:after, .body--dark .complete-icon--success:before {
  background: $background;
}

.body--dark .complete-icon--success.bg-responsive:after, .body--dark .complete-icon--success.bg-responsive:before {
  background: $dark;
}
@keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px
  }
  to {
    width: 47px;
    right: 8px;
    top: 38px
  }
}

@keyframes rotatePlaceholder {
  0% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
  }
  5% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
  }
  12% {
    -webkit-transform: rotate(-405deg);
    transform: rotate(-405deg)
  }
  to {
    -webkit-transform: rotate(-405deg);
    transform: rotate(-405deg)
  }
}

@keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px
  }
  to {
    width: 25px;
    left: 14px;
    top: 45px
  }
}
</style>
